export const trackCustomEvent = async (pageAction, pageActionData = {}) => {
  if (typeof window._satellite === 'undefined' || !window._satellite) {
    return;
  }

  try {
    window._satellite.track('event', {
      xdm: {},
      data: {
        web: {
          webInteraction: {
            name: pageAction,
            URL: window.location.href
          }
        },
        _adobe_corpnew: {
          digitalData: pageActionData
        }
      }
    });
  } catch (error) {
    if (window._satellite.environment.stage !== 'production') {
      console.error(`Failed to track event '${pageAction}':`, error);
    }
  }
};

export const trackPageLoad = () => {
  if (typeof window._satellite === 'undefined' || !window._satellite) {
    return;
  }

  window._satellite.track('pageload');
};
